import React, { memo, useEffect, useState } from "react";
import ConfettiExplosion from "react-confetti-explosion";
import CustomModal from "../../../layouts/Modal";
import Button from "../../../common/Button";
import stay from "../../../assets/icons/stay.png";
import usdc from "../../../assets/icons/usdc.png";
import image1 from "../../../assets/images/progress1_1.png";
import image2 from "../../../assets/images/progress1_2.png";
import image3 from "../../../assets/images/progress1_3.png";
import image4 from "../../../assets/images/progress1_4.png";
import { useNfstay } from "../../../context/ThemeContext";
import { router, stayAddress, usdcAddress } from "../../../utils/constants";
import { ethers } from "ethers";
import BLoader from "../../../common/BLoader";
import toast from "react-hot-toast";
import { useAccount } from "wagmi";

const USDCModal = ({ setStayValue, stayValue, onHide }) => {
  const { address: account } = useAccount();
  const [isApproved, setIsApproved] = useState(false);
  const { getRouterContract, approveUSDCtoRouter, USDCApprovaltoRouter } = useNfstay();
  const [isExploding, setIsExploding] = React.useState(false);
  const [status, setStatus] = useState({ isApproved: false, isBuy: false });
  const [showLast, setShowLast] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);

  const handleApprove = async () => {
    try {
      setIsLoading1(true);
      await approveUSDCtoRouter();
      setStatus({ isApproved: true, isBuy: false });
      setIsApproved(true);
    } catch (e) {
      toast.error(e.reason || e.message || "Something went wrong");
    } finally {
      setIsLoading1(false);
    }
  };

  const handleSwap = async () => {
    try {
      setIsLoading(true);
      const path = [usdcAddress, stayAddress];
      const swap = await getRouterContract(true).swapExactTokensForTokens(
        ethers.utils.parseEther(stayValue),
        0,
        path,
        account,
        Math.floor(Date.now() / 1000) + 5 * 10 * 10,
      );
      await swap.wait();
      toast.success("Transaction Successful");

      setStatus({ isApproved: true, isBuy: true });
      setStayValue("");
      setIsExploding(true);
      setShowLast(true);
      setTimeout(() => {
        onHide();
      }, 2000);
    } catch (e) {
      console.log(e);
      toast.error(e.reason || e.message || "Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (USDCApprovaltoRouter) {
      setStatus({ isApproved: true, isBuy: false });
    }
  }, []);

  return (
    <CustomModal
      title="Buy STAY"
      onHide={onHide}
    >
      {isExploding && (
        <div className="flex justify-center">
          <ConfettiExplosion
            particleCount={500}
            zIndex={999999}
          />
        </div>
      )}
      <div className="pl-4 relative">
        {!showLast ? (
          <img
            className="absolute -left-1 h-[193px] sm:h-[207px] top-[3px]"
            src={
              !status.isApproved && !status.isBuy
                ? image1
                : status.isApproved && !status.isBuy
                  ? image2
                  : status.isApproved && status.isBuy
                    ? image3
                    : image4
            }
            alt="step"
          />
        ) : (
          <img
            className="absolute -left-1 h-[193px] sm:h-[207px] top-[3px]"
            src={image4}
            alt="step"
          />
        )}
        <div>
          <div className="flex justify-between items-center mb-2">
            <div>
              <p className="text-main font-bold">{isLoading ? <BLoader /> : "Approve USDC"}</p>
            </div>
            <span className="max-sm:text-sm text-main opacity-70 font-medium">Step 1</span>
          </div>
          <Button
            onClick={handleApprove}
            className="w-full flex items-center gap-2 justify-center text-main"
            disabled={status.isApproved || isLoading1}
            style={{
              color: status.isApproved ? "var(--main)" : "#FFFFFF",
              background: status.isApproved
                ? `linear-gradient(90.57deg, rgba(153, 69, 255, 0.2) 0%, rgba(32, 225, 159, 0.2) 100%)`
                : "var(--primary)",
            }}
          >
            {isLoading1 ? (
              <BLoader />
            ) : (
              <>
                {!status.isApproved ? (
                  <>
                    <img
                      src={usdc}
                      alt="USDC"
                      className="size-6"
                    />
                    Approve USDC
                  </>
                ) : (
                  "Approved"
                )}
              </>
            )}
          </Button>
        </div>

        <div className="mt-3">
          <div className="flex justify-between items-start mb-2">
            <div>
              <p className="text-main font-bold">Buy STAY</p>
            </div>
            <span className="max-sm:text-sm text-main opacity-70 font-medium">Step 2</span>
          </div>
          <Button
            className={`w-full flex items-center gap-2 justify-center border border-primary text-main`}
            style={{
              color: status.isApproved && !status.isBuy ? "#FFFFFF" : "var(--main)",
              background:
                status.isApproved && !status.isBuy
                  ? "var(--primary)"
                  : `linear-gradient(90.57deg, rgba(153, 69, 255, 0.2) 0%, rgba(32, 225, 159, 0.2) 100%)`,
            }}
            onClick={() => handleSwap()}
            disabled={!status.isApproved || isLoading}
          >
            {isLoading ? (
              <BLoader />
            ) : (
              <>
                <img
                  src={stay}
                  alt="Stay"
                  className="size-6"
                />
                Buy STAY
              </>
            )}
          </Button>
        </div>
        <div className="mt-3">
          <div className="flex justify-between items-start mb-2">
            <div>
              <p className="text-main font-bold">Success</p>
            </div>
          </div>
        </div>
      </div>
    </CustomModal>
  );
};

export default memo(USDCModal);
